import React, { useRef, useState } from "react";
import { filterOptions, QFilters } from "./question-prompts.hooks";

export { filterOptions };

export const useQuestionSearch = (
	search: (term: string) => void,
	setFilter: (filter: QFilters) => void,
) => {
	const [userSearchTerm, setUserSearchTerm] = useState('');
	const [selectedFilter, setSelectedFilter] = useState(QFilters.all);
	const hasActiveSearch = useRef(false);

	const hasActiveFilter = selectedFilter !== QFilters.all || userSearchTerm.length > 0;

	const handleSearchChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
		setUserSearchTerm(value);
		if (value.length === 0 && hasActiveSearch.current) {
			hasActiveSearch.current = false;
			search('');
		}
	};

	const handleSearch = () => {
		if (userSearchTerm.length > 2) {
			hasActiveSearch.current = true;
			search(userSearchTerm);
		} else {
			hasActiveSearch.current = false;
			search('');
		}
	};

	const handleFilterChange = (filter: QFilters) => {
		setSelectedFilter(filter);
		setFilter(filter);
	};

	return {
		userSearchTerm,
		selectedFilter,
		hasActiveFilter,
		handleSearchChange,
		handleSearch,
		handleFilterChange,
	};
};
